import styled from 'styled-components'

const ItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
`

export default ItemHeader
